import { DOCUMENT } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { InfosUser } from 'app/shared/models/class/auth/infosUser';
import { FullOffer } from 'app/shared/models/class/offer/offer';
import { Tag } from 'app/shared/models/class/tags/tag';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { ColorService } from 'app/shared/services/color/color.service';
import { DataService } from 'app/shared/services/data/data.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { NoticeService } from 'app/shared/services/notice/notice.service';
import { OfferService } from 'app/shared/services/offer/offer.service';
import { TagService } from 'app/shared/services/tag/tag.service';
import { UniverseService } from 'app/shared/services/universe/universe.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';
import * as moment from 'moment';

@Component({
  selector: 'app-open-dialog-search-mobile',
  templateUrl: './open-dialog-search-mobile.component.html',
  styleUrls: ['./open-dialog-search-mobile.component.scss']
})
export class OpenDialogSearchMobileComponent extends SubscriptionBaseComponent implements OnInit {

  showTags: boolean;

  valueInput: string;
  searchForm: UntypedFormGroup;
  coordinatesSearch: any;
  universe = 1;
  tags: Tag[] = [];
  tagsSelected: Tag[] = [];
  userConnected: InfosUser;
  cooordinates: string;
  color: ThemePalette = 'primary';
  colorsTag: any;
  listUniverses = [];
  isLoading: boolean;
  valueKM = 50;
  universeSelected: string | number;
  latitude: number;
  longitude: number;
  searchTxt: string;
  currentDate: string;
  listOffers: FullOffer[] = [];

  private static readonly DEMO_THEME_CLASS = 'demo';
  private static readonly DEMO_THEME_LIGHT = 'light';
  private static readonly DEMO_THEME_DARK = 'dark';

  public theme: string;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private dataService: DataService,
    private route: ActivatedRoute,
    private offerService: OfferService,
    private authService: AuthService,
    private router: Router,
    private tagsService: TagService,
    private cdr: ChangeDetectorRef,
    private colorService: ColorService,
    private faIconService: FaiconService,
    private universeService: UniverseService,
    private noticeService: NoticeService,
    public dialogRef: MatDialogRef<OpenDialogSearchMobileComponent>,
    @Inject(DOCUMENT) private document: Document) {
    super();
    this.theme = this.document.documentElement.classList.contains(OpenDialogSearchMobileComponent.DEMO_THEME_CLASS) ?
      OpenDialogSearchMobileComponent.DEMO_THEME_DARK : OpenDialogSearchMobileComponent.DEMO_THEME_LIGHT;
  }

  ngOnInit(): void {
    this.initComponent();
    this.initForm();
    this.initSub();
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  getAddressSearch(event, confirm: boolean = false) {
    this.valueInput = this.f.keyword.value;
    this.coordinatesSearch = event;
    this.cooordinates = event ? this.formatCoord(event) : this.cooordinates;
    const tagString = this.tagsSelected.map(t => t.tagKey).join(';');
    this.noticeService.detailsImage$.next({ bool: false });

    sessionStorage.setItem('coordinates', JSON.stringify(event));

    this.getOfferWithTags(tagString, this.cooordinates);

    if (confirm) {
      this.dialogRef.close();
    }
  }

  resetSearch(): void {
    this.f.keyword.reset();
    sessionStorage.removeItem('coordinates');
    this.valueInput = null;
    const tagString = this.tagsSelected.map(t => t.tagKey).join(';');
    this.getOfferWithTags(tagString, '');
  }

  addTag(tag: Tag): void {
    this.tagsSelected.push(tag);
    this.dataService.tagSelected$.next(this.tagsSelected);
  }

  removeTag(tag: Tag): void {
    const index = this.tagsSelected.findIndex(t => t.tagKey === tag.tagKey);
    this.tagsSelected.splice(index, 1);
    this.dataService.tagSelected$.next(this.tagsSelected);
  }

  goToUniverseWithQueryParam(universe: number): void {
    const { structure } = this.route.snapshot.queryParams;
    // const user = this.authService.getDecodedToken();

    this.searchTxt = null;
    this.searchForm.get('keyword').setValue(null);
    this.universeSelected = universe;

    this.universe = universe;
    this.getTags();

    this.noticeService.detailsImage$.next({ bool: false });

    if (structure) {
      this.router.navigate(['/home'], {
        queryParams: {
          structure,
          universe
        }
      });
    } else {
      this.router.navigate(['/home'], {
        queryParams: {
          universe
        }
      });
    }

    universe === 5 ? this.selectDarkTheme() : this.selectLightTheme();


    const tagString = this.tagsSelected.map(t => t.tagKey).join(';');
    this.universe = universe;
    const coordinates = this.formatCoord(this.coordinatesSearch) || '';

    this.getOfferWithTags(tagString, coordinates, this.universe);
    // this.openSearch = !this.openSearch;
  }


  universIsSelected(indexUniverse: number): boolean {
    const { universe } = this.route.snapshot.queryParams;
    let isSelected = false;

    if (+universe === indexUniverse || (!universe && indexUniverse === 5)) {
      isSelected = true;
    }
    return isSelected;
  }

  isInTagSelected(tag: string): boolean {
    const index = this.tagsSelected.findIndex(t => t.tagName === tag);
    return index === -1 ? true : false;
  }

  getValueColorTag({ colorKey }): string {
    return '#' + this.colorsTag?.find(c => c.colorKey === colorKey)?.value;
  }

  getValueKM(event: any): void {
    this.valueKM = event.value;
    this.getOffers();
  }

  private getListOffers(offersFilter: any, offersList: FullOffer[]): FullOffer[] {
    let offers: FullOffer[] = [];
    let array_key: number[] = offersFilter.map((o: any) => o.key);
    offersList.forEach(offer => {
      if (array_key.includes(offer.offerKey)) {
        offers.push(offer);
      }
    });
    return offers;
  }

  private getOffers(text?: string): void {
    let offersFilter: any;

    if (this.universeSelected === 5) {
      const params = {
        date: this.currentDate,
        text: this.searchTxt,
        distance: this.valueKM < 205 ? this.valueKM * 1000 : undefined,
        lat: this.latitude,
        lng: this.longitude
      };
      this.offerService.getOffersByFilter(params).subscribe({
        next: datas => {
          offersFilter = datas;
          this.dataService.offersHome$.next(this.getListOffers(offersFilter, this.listOffers));
        }
      });

    }
    else {
      if (text) {
        this.offerService.getOffersByText(text).subscribe({
          next: datas => {
            offersFilter = datas;
            this.dataService.offersHome$.next(this.getListOffers(offersFilter, this.listOffers));
          }
        })
      }
    }
  }

  private formatCoord(event): string {
    this.coordinatesSearch = event;
    const coordinates = [];

    switch (typeof event?.geometry?.location.lat) {
      case 'function':
        coordinates.push(event?.geometry.location.lat().toString().replace('.', ','));
        coordinates.push(event?.geometry.location.lng().toString().replace('.', ','));
        break;
      case 'number':
        coordinates.push(event?.geometry.location.lat.toString().replace('.', ','));
        coordinates.push(event?.geometry.location.lng.toString().replace('.', ','));
        break;

      default:
        break;
    }

    return coordinates.join(';');
  }

  private getOfferWithTags(tagString: string, coordinates: string = '', universeChange?: number): void {
    this.dataService.loadingOfferHome$.next(false);

    const structure = this.route.snapshot.queryParams.structure || '';
    const universe = this.universe ? this.universe : (this.route.snapshot.queryParams.universe || '');

    this.offerService.getOfferTag(tagString, coordinates, structure, universe).subscribe({
      next: offers => {
        this.listOffers = offers;
        if (universe === 5) {
          this.getOffers();
        } else {
          this.searchTxt ? this.getOffers(this.searchTxt) : this.dataService.offersHome$.next(offers);
        }
        this.dataService.offersHome$.next(offers);
        this.dataService.loadingOfferHome$.next(true);
      }
    });

  }

  private getTags(): void {
    const tempoTag = [];
    this.tags = [];
    this.tagsService.getTagsByUniverse(this.universeSelected).subscribe({
      next: tags => {
        tags.forEach(t => {
          if (t.isActive) {
            t.tags.forEach(tag => {
              tempoTag.push(tag);
            });
          }
        });

        for (let i = 1; i < this.colorsTag?.length + 1; i++) {
          const colorOrder = this.colorsTag.find(c => c.order === i);
          const tempo = tempoTag.filter(t => t.colorKey === colorOrder.colorKey && t.isActive).sort((a, b) => a.tagName.toLowerCase() - b.tagName.toLowerCase());

          tempo.forEach(item => {
            const index = this.tags.findIndex(t => t.tagName.trim() === item.tagName.trim());
            if (index === -1) { this.tags.push(item); }
          });

          // this.tags = [...this.tags, ...tempo];
        }
      }
    });
  }

  private getColorTags(): void {
    this.colorService.getColors().subscribe({
      next: colorsTag => {
        this.colorsTag = colorsTag;
        this.getTags();
      }
    });
  }

  private selectDarkTheme(): void {
    this.document.documentElement.classList.add(OpenDialogSearchMobileComponent.DEMO_THEME_CLASS);
    this.dataService.themeDemo$.next(true);
    this.theme = OpenDialogSearchMobileComponent.DEMO_THEME_DARK;
  }

  private selectLightTheme(): void {
    const user = this.authService.getDecodedToken()?.name;
    if (user?.toLowerCase().includes('demo')) {
      this.selectDarkTheme();
    } else {
      this.document.documentElement.classList.remove(OpenDialogSearchMobileComponent.DEMO_THEME_CLASS);
      this.dataService.themeDemo$.next(false);
      this.theme = OpenDialogSearchMobileComponent.DEMO_THEME_LIGHT;
    }
  }

  private initComponent(): void {
    this.currentDate = moment(new Date()).format('yyyy-MM-DD');

    let universe = 5;
    if (this.route.snapshot.queryParams.universe) {
      universe = parseInt(this.route.snapshot.queryParams.universe);
    }
    this.universeSelected = universe;

    this.isLoading = true;
    this.userConnected = this.authService.getDecodedToken();
    this.universeService.getUniverse().subscribe({
      next: data => {
        this.isLoading = false;
        this.listUniverses = data;
      },
      error: () => this.isLoading = false
    });
    this.getColorTags();
  }

  get f() {
    return this.searchForm.controls;
  }

  private initForm(): void {
    let coordinates = null;
    if (sessionStorage.getItem('coordinates')) {
      coordinates = JSON.parse(sessionStorage.getItem('coordinates'));
      if (coordinates) {
        this.valueInput = coordinates.name;
      }
    }

    this.searchForm = this.formBuilder.group({
      keyword: [coordinates?.name || '', Validators.required],
      startDate: [this.currentDate, Validators.required],
      km: [this.valueKM],
      search: [null],
      slider: [{ value: this.valueKM, disabled: true}]
    });

    this.searchForm.get('startDate').valueChanges.subscribe(value => {
      this.currentDate = value.format('yyyy-MM-DD');
      this.getOffers();
    });

    this.searchForm.get('keyword').valueChanges.subscribe(value => {
      if (value) {
        this.searchForm.get('slider').enable();
      } else {
        this.searchForm.get('slider').disable();
      }
    });

    this.searchForm.get('search').valueChanges.subscribe(value => {

      if (value.length > 2) {
        this.searchTxt = value;
        if (this.universeSelected === 5) {
          this.getOffers();

        } else {
          this.getOffers(value);
        }

      } else {
        this.searchTxt = null;
        if (this.universeSelected === 5) {
          this.getOffers();
        } else {
          this.dataService.offersHome$.next([]);
        }
      }
    });
  }

  private initSub(): void {
    this.subscription
    .add(
      this.dataService.tagSelected$.subscribe({
        next: tags => {
          this.tagsSelected = tags;
          this.cdr.detectChanges();
        }
      })
    )
  }

}
